<template lang="pug">
  div.d-contents
    slot(v-bind="slotExpose")
</template>

<script>
import WorkerInterval from '@/utils/worker-interval';

const SECONDS_IN_MINUTE = 60;

export default {
  name: 'DTimer',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    seconds: {
      type: [Number, String],
      required: true,
    },
    autoStart: {
      type: Boolean,
      default: false,
    },
    expiredMessage: {
      type: String,
      default: 'Время вышло',
    },
  },
  data() {
    return {
      worker: null,
      timeLeft: 0,
      started: false,
      loading: true,
    };
  },
  computed: {
    running() {
      return this.value === true;
    },
    minutes() {
      return Math.floor(this.timeLeft / SECONDS_IN_MINUTE);
    },
    secondsFormatted() {
      const s = this.timeLeft % SECONDS_IN_MINUTE;
      return s < 10 ? `0${s}` : s;
    },
    isExpired() {
      return (
        (this.timeLeft <= 0 && this.started)
        || !this.seconds
      );
    },
    slotExpose() {
      return {
        init: this.init,
        stop: this.stop,
        loading: this.loading,
        running: this.running,
        isExpired: this.isExpired,
        timeLeft: this.timeLeft,
        minutes: this.minutes,
        seconds: this.secondsFormatted,
        expiredMessage: this.expiredMessage,
      };
    },
  },
  watch: {
    isExpired(val) {
      if (val) {
        this.stop();
        this.$emit('expired');
      }
    },
  },
  mounted() {
    if (this.seconds != null && this.autoStart) {
      this.init(Number(this.seconds));
    } else {
      this.loading = false;
    }
  },
  beforeDestroy() {
    this.teardown();
  },
  methods: {
    init(seconds) {
      this.teardown();
      const secs = Number(seconds ?? this.seconds ?? 0);
      this.timeLeft = Math.max(0, secs);
      this.started = true;

      if (secs <= 0) {
        this.loading = false;
        this.$emit('input', false);
        this.$nextTick(() => this.$emit('expired'));
        return;
      }

      this.loading = true;
      this.worker = new Worker(WorkerInterval);
      this.worker.onmessage = ({ data: { time } }) => {
        this.timeLeft = time;
        this.loading = false;
      };
      this.worker.postMessage({ turn: 'on', seconds: secs });
      this.$emit('input', true);
    },
    stop() {
      if (this.worker) {
        this.worker.postMessage({ turn: 'off' });
      }
      this.$emit('input', false);
    },
    teardown() {
      if (this.worker && typeof this.worker.terminate === 'function') {
        this.worker.terminate();
      }
      this.worker = null;
    },
  },
};
</script>
